import notification from 'app/config/notification';
import { validateDocumentsDescription } from '../functions';
import { withSchedulesTable } from '../services/lines';
import { SERVICES_CODES } from '../../../config/services';

const filterBoExcluido = data => {
  if (!data) return [];
  return data.filter(c => !c.boExcluido);
};

export const validateLineRequest = ({ values, cdServico, intl, isInternalForm }) => {
  const docsExtrasValidation = validateDocumentsDescription(values.documentos);
  let errors = {};

  if (!isInternalForm && values.documentos?.length === 0) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_INFOS' }), {
      toastId: 'MISSING_MANDATORY_INFOS',
      type: 'warning',
    });
    errors.documents = true;
    return errors;
  }

  if (!docsExtrasValidation && !isInternalForm) {
    notification(
      intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }),
      {
        toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
        type: 'error',
      }
    );
    errors.documents = true;
  }

  if (withSchedulesTable.includes(cdServico)) {
    const quadroHorarios = values.quadroHorarios || { horarios: [] };
    let horarios = filterBoExcluido(quadroHorarios.horarios);
    if (!horarios || horarios.length === 0) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_LINE_SCHEDULE' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_LINE_SCHEDULE',
        type: 'error',
      });
      errors.schedules = true;
    }
  }

  if (SERVICES_CODES.STRIP_CONEXAO_LINHAS === cdServico) {
    if (!values.linhasSolicitacao || values.linhasSolicitacao.length === 0) {
      notification(
        intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_SECOND_LINE' }),
        {
          toastId: 'MESSAGES.SERVICE.FORMS.MISSING_SECOND_LINE',
          type: 'error',
        }
      );
      errors.linesRequest = true;
    }
  }

  if (SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA === cdServico) {
    if (!values.linhasSolicitacao || values.linhasSolicitacao.length === 0) {
      notification(
        intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_LINES_SELECTION' }),
        {
          toastId: 'MESSAGES.SERVICE.FORMS.MISSING_LINES_SELECTION',
          type: 'error',
        }
      );
      errors.linesRequest = true;
    }
  }

  return errors;
};